<template>
  <div class="header" v-if="$store.getters.getSiteInfo">
    <div class="logo" @click="toIndex">
      <img :src="$store.getters.getSiteInfo.logal" :alt="$store.getters.getSiteInfo.name">
    </div>
    <div class="right">
      <div class="lianxi" @click="mouseOverMenu">
        <div class="box">
            <img src="~assets/icons/menuli.png">
        </div>
      </div>
    </div>

<!-- 弹出菜单窗口 开始	-->

    <el-dialog  title="菜单" :visible.sync="showMenu" center :before-close="handleClose" width="100%" top="0px">
      <div label-width="100px" style="display: flex; flex-direction: column; align-items: center">

        <div class="loginli">
          <div class="info-content"></div>
        </div>
        <div v-if="$store.getters.getUserInfo" class="nav-li">
	  <div class="nav-l">
	    <ul>
	      <li>
		<a href="/m/account/mycenter">
	        <div class="nvli-img"><img src="~assets/icons/1home.png"></div>
		<div class="nvli-tt">主页</div>
		</a>
	      </li>
	      <li>
		<a href="/m/orderAdmin/purchase">
	        <div class="nvli-img"><img src="~assets/icons/2piliang.png"></div>
		<div class="nvli-tt">礼品下单</div>
		</a>
	      </li>
<!-- 
	      <li>
		<a href="/m/orderAdmin/purchaseNosource">
	        <div class="nvli-img"><img src="~assets/icons/nosource_m.png"></div>
		<div class="nvli-tt">无货源单</div>
		</a>
	      </li>
-->
	      <li>
		<a href="/m/orderAdmin/purchaseFast">
	        <div class="nvli-img"><img src="~assets/icons/fastsend_m.png"></div>
		<div class="nvli-tt">快速下单</div>
		</a>
	      </li>
	      <li>
		<a href="/m/orderAdmin/orderList">
	        <div class="nvli-img"><img src="~assets/icons/3dingdan.png"></div>
		<div class="nvli-tt">订单管理</div>
		</a>
	      </li>
	      <li>
		<a href="/m/orderAdmin/parcelList">
	        <div class="nvli-img"><img src="~assets/icons/4baouo.png"></div>
		<div class="nvli-tt">包裹管理</div>
		</a>
	      </li>
	      <li>
		<a href="/m/orderAdmin/storeBind">
	        <div class="nvli-img"><img src="~assets/icons/storebind_m.png"></div>
		<div class="nvli-tt">绑定店铺</div>
		</a>
	      </li>
	      <li>
		<a href="/m/account/recharge">
	        <div class="nvli-img"><img src="~assets/icons/5congzhi_m.png"></div>
		<div class="nvli-tt">充值</div>
		</a>
	      </li>
	      <li>
		<a href="/m/account/capitalFlow">
	        <div class="nvli-img"><img src="~assets/icons/6liushui.png"></div>
		<div class="nvli-tt">资金明细</div>
		</a>
	      </li>
	      <li>
		<a href="/m/account/realnameAuth">
	        <div class="nvli-img"><img src="~assets/icons/realauth_m.png"></div>
		<div class="nvli-tt">实名认证</div>
		</a>
	      </li>
	      <li>
		<a href="/m/account/inviteFriends">
	        <div class="nvli-img"><img src="~assets/icons/7fenxiang-m.png"></div>
		<div class="nvli-tt">推广分享</div>
		</a>
	      </li>
	      <li>
		<a href="javascript:;" @click="logout">
	        <div class="nvli-img"><img src="~assets/icons/8out.png"></div>
		<div class="nvli-tt">退出登录</div>
		</a>
	      </li>
	    </ul>
	  </div>
        </div>

        <div v-else class="nav-li">
	  <div class="nav-l">
	    <ul>
	      <li>
		<a href="/m/login">
	        <div class="nvli-img"><img src="~assets/icons/1home.png"></div>
		<div class="nvli-tt">登陆</div>
		</a>
	      </li>
	      <li>
		<a href="/m/register">
	        <div class="nvli-img"><img src="~assets/icons/2piliang.png"></div>
		<div class="nvli-tt">免费注册</div>
		</a>
	      </li>
	    </ul>
	  </div>
        </div>

      </div>
    </el-dialog>

<!-- 弹出菜单窗口 结束	-->

  </div>
</template>

<script>
export default {
  inject: ['reload'],
  data() {
    return {
      showMenu: false,
      showKefu: false,
      showUser: false,
      showQR: false,
      count: 0
    }
  },
  props: {
    indexPath: String
  },
  // mounted() {
  //   this.handleShow()
  // },
  methods: {
    toLogin () {
      this.$router.push('/login')
    },
    toRegister () {
      this.$router.push('/m/register')
    },
    toIndex() {
      this.$router.push('/')
    },
    menuItemClick(index) {
      switch (index) {
        case 0:
          this.$router.push('/m/')
          break
        case 1:
          this.$router.push('/m/goods')
          break
        case 2:
          this.$router.push('/m/account/mycenter')
          break
        case 3:
          this.$router.push('/m/orderAdmin/purchase')
          break
        case 4:
          this.$router.push('/m/account/myprice')
      }
    },
    // 跳转到第三方链接
    goPage(url) {
      window.location.href = url
    },
    handleClose () {
	this.showMenu = false
    },
    mouseOverMenu() {
      this.showMenu = true
    },
    mouseLeaveMenu() {
      this.showMenu = false
    },
    mouseOverKefu() {
      this.showKefu = true
    },
    mouseLeaveKefu() {
      this.showKefu = false
    },
    mouseOverUser() {
      this.showUser = true
    },
    mouseLeaveUser() {
      this.showUser = false
    },
    mouseOverQR() {
      this.showQR = true
    },
    mouseLeaveQR() {
      this.showQR = false
    },
    toUser() {
      this.$router.push('/m/account/base')
    },
    // 点击在线客服
    clickKefu() {
      window.open(this.$store.getters.getSiteInfo.online_service, '_blank')
    },
    refresh() {
      this.reload()
    },
    // 退出登录
    logout() {
      this.$confirm('真的要注销登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.refresh()
        // 清楚用户信息,退出登录
        // this.$store.dispatch('logout')
        // localStorage.removeItem('userInfo')
        // localStorage.removeItem('token')
        localStorage.clear()// 清除缓存
        setTimeout(() => { location.reload() }, 200)
        this.$router.push('/index')
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped src="styles/components/adminHeader.css">
</style>
